import { render, staticRenderFns } from "./TabMultisigOrdersList.vue?vue&type=template&id=019eed32"
import script from "./TabMultisigOrdersList.vue?vue&type=script&lang=js"
export * from "./TabMultisigOrdersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports